<div class="p-3 relative">
  <div class="page-title d-flex justify-content-between align-items-center px-1">
    <h3>Chatbot Logs</h3>
  </div>

  <!-- <div class="filter-section d-flex align-items-center justify-content-between flex-wrap mt-3">
  <div class="radio-group d-flex align-items-center gap-3">
    <label>
      <input type="radio" name="dateRange" [(ngModel)]="filters.start" [value]="14" (ngModelChange)="getChatLogs()" />
      Last 14 Days
    </label>

    <label>
      <input type="radio" name="dateRange" [(ngModel)]="filters.start" [value]="7" (ngModelChange)="getChatLogs()" />
      Last 7 Days
    </label>

    <label>
      <input type="radio" name="dateRange" [(ngModel)]="filters.start" [value]="1" (ngModelChange)="getChatLogs()" />
      Last 24 Hours
    </label>
  </div>
</div> -->

  <div class="property-categories-listing data-table-container mt-2 bg-white p-4">
    <p-table #dt2 [value]="logs" [lazy]="true" responsiveLayout="scroll" [paginator]="true" [rows]="itemsPerPage"
      [totalRecords]="totalRecords" (onLazyLoad)="getChatLogs($event)" [sortField]="sorting.field"
      [sortOrder]="sorting.order" [rowsPerPageOptions]="[10,20,50]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" selectionMode="single"
      [loading]="isLoading" [(selection)]="selectedChat" (onRowSelect)="onRowSelect($event)"
      [globalFilterFields]="['root.outputs.answer', 'contactInfo.first_name', 'contactInfo.last_name', 'contactInfo.email', 'contactInfo.phone_number','contactInfo.chat_date', 'source']"
      dataKey="thread_id">

      <ng-template pTemplate="caption">
        <div class="filters">
          <div class="row align-items-center">
            <div class="col-lg-2 col-12">
              <div class="p-1 w-100">
                <label for="website_chat">Website Chat</label>
                <label class="switch">
                  <input type="checkbox" name="website_chat" [(ngModel)]="isToggled" (change)="toggleChanged()">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
            <div class="col-lg-3 col-12">
              <div class="p-1 w-100">
                <label for="search">Search</label>
                <input class="form-control" id="searchLogs" name="search" pInputText type="text"
                  (input)="dt2.filterGlobal($any($event).target?.value, 'contains'); sanitizeInput($event)"
                  (keydown)="blockSpecialChars($event)" (paste)="blockSpecialCharsOnPaste($event)"
                  (drop)="blockSpecialCharsOnDrop($event)" placeholder="Search..." />
              </div>
            </div>
            <div class="col-lg-3 col-12">
              <div class="p-1 w-100">
                <div class="d-flex flex-column">
                  <label for="start_date">Date</label>
                  <p-calendar styleClass="w-100" [disabled]="false" [(ngModel)]="dateRange" selectionMode="range"
                    dateFormat="mm/dd/yy" appendTo="body" placeholder="Date Range" [showIcon]="true"
                    (onSelect)="onDateRangeChange()" [numberOfMonths]="2" [showClear]="true"
                    (ngModelChange)="onDateRangeChange()">
                  </p-calendar>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-12">
              <div class="p-1 w-100">
                <label for="source">Source</label>
                <p-dropdown [options]="leadSourceOptions" [(ngModel)]="filters.source" placeholder="Select Source"
                  (onChange)="onSourceChange()" [showClear]="true" filter="true"></p-dropdown>
              </div>
            </div>
            <!-- <div class="col-lg-3 col-12">
              <div class="p-1 w-100">
                <label for="user_name">Resident</label>
                <p-dropdown [options]="agents" [(ngModel)]="filters.user_name" placeholder="Select Resident" (onChange)="onResidentChange()" [showClear]="true" filter="true"></p-dropdown>
              </div>
            </div> -->
            <!-- <div class="col-lg-3 col-12">
              <div class="p-1 w-100">
                <label for="website_chat">Website Chat</label>
                <label class="switch">
                  <input type="checkbox" name="website_chat" [(ngModel)]="isToggled" (change)="toggleChanged()">
                  <span class="slider round"></span>
                </label>
              </div>
            </div> -->
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>Chat Date</th>
          <th>Lead Name</th>
          <th>Lead Email</th>
          <th>Lead Phone</th>
          <th>Lead Source</th>
          <th>Message Count</th>
          <th>Recent Activity</th>
          <th>Lead Chat Log</th>
          <th>Tour Summary</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-log>
        <tr>
          <td>{{ formatChatDate(log) }}</td>
          <td>{{ (log.contactInfo?.first_name || '') + (log.contactInfo?.last_name ? ' ' + log.contactInfo.last_name : '') }}
          </td>
          <td>{{ log.contactInfo?.email }}</td>
          <td>{{ log.contactInfo?.phone_number }}</td>
          <td>
            <ng-container [ngSwitch]="log.source">
              <span *ngSwitchCase="'WEB'">🌐 WEB</span> <!-- Web icon -->
              <span *ngSwitchCase="'SMS'">💬 SMS</span> <!-- SMS icon -->
              <span *ngSwitchCase="'CALL'">📞 Call</span> <!-- Call icon -->
              <span *ngSwitchDefault>-</span> <!-- Default info icon -->
            </ng-container>
          </td>
          <td>{{ log.history.length }}</td>
          <td>{{ formatRecentActivity(log) }}</td>
          <td>{{ hostName+'/'+user.fullName+'/chatlog/'+log.thread_id}}</td>
          <td [pSelectableRow]="log">ℹ️</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <app-history-chat-logs *ngIf="isOpen" [contactInfo]="contactInfo" [logs]="selectedChat?.history"
    [source]="selectedChat?.source" (close)="isOpen=false" [hostName]="hostName" [propertyName]="user.fullName"
    [propertyNumber]="selectedChat?.property_number" [senderNumber]="selectedChat?.sender_number"
    [propertyTimezone]="propertyTimezone"></app-history-chat-logs>

  <!-- <div class="chatbot-btn">
    <p-button class="rounded-lg-icon-btn" (click)="isOpen = !isOpen;">
      <ng-container *ngIf="!isOpen; else closeIcon">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          xmlns:svgjs="http://svgjs.dev/svgjs" id="Layer_1" viewBox="0 0 512 512" data-name="Layer 1" width="50"
          height="50" version="1.1">
          <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
            <path
              d="m12 45.341a19.24 19.24 0 0 1 19.222-19.22h362.466a19.24 19.24 0 0 1 19.223 19.22v243.751a19.241 19.241 0 0 1 -19.223 19.219h-248.525a6.017 6.017 0 0 0 -3.255.951l-129.908 83.559zm468.772 56.851h-55.86v-56.851a31.262 31.262 0 0 0 -31.224-31.221h-362.467a31.257 31.257 0 0 0 -31.221 31.221v358.472a6.007 6.007 0 0 0 9.251 5.048l77.842-50.069v18.359a31.252 31.252 0 0 0 31.217 31.22h246.769l137.674 88.551a6 6 0 0 0 9.245-5.04v-358.482a31.254 31.254 0 0 0 -31.227-31.208z"
              fill-rule="evenodd" fill="#000000" fill-opacity="1" data-original-color="#000000ff" stroke="none"
              stroke-opacity="1" />
          </g>
        </svg>
      </ng-container>

      <ng-template #closeIcon>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" height="24"
          viewBox="0 0 24 24" width="24">
          <clipPath id="clip0_3_1192">
            <path d="m0 0h24v24h-24z" />
          </clipPath>
          <g clip-path="url(#clip0_3_1192)">
            <path clip-rule="evenodd"
              d="m5.2928 5.29289c.39053-.39052 1.02369-.39052 1.41421 0l5.29289 5.29291 5.2929-5.29291c.3905-.39052 1.0237-.39052 1.4142 0 .3905.39053.3905 1.02369 0 1.41422l-5.2929 5.29289 5.2929 5.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-5.2929-5.2929-5.29289 5.2929c-.39052.3905-1.02368.3905-1.41421 0-.39052-.3905-.39052-1.0237 0-1.4142l5.2929-5.2929-5.2929-5.29289c-.39052-.39053-.39052-1.02369 0-1.41422z"
              fill="#212121" fill-rule="evenodd" />
          </g>
        </svg>
      </ng-template>
    </p-button>
  </div> -->

</div>